var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15 19.403v-8.54c0-.425-.168-.833-.469-1.133l-2.263-2.263c-.3-.3-.707-.469-1.132-.469h-5.54a1.6 1.6 0 00-1.6 1.6v10.805a1.6 1.6 0 001.6 1.6H13.4a1.6 1.6 0 001.6-1.6z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.002 17.002h3.402a1.6 1.6 0 001.6-1.6V6.86c0-.425-.169-.833-.469-1.133l-2.263-2.263c-.3-.3-.707-.469-1.132-.469H10.6a1.6 1.6 0 00-1.6 1.6v2.402",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.006 6.998h-3.202a.8.8 0 01-.8-.8V2.995M15.002 11H11.8a.8.8 0 01-.8-.8V6.997",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCopyText;